import Vue from 'vue'
import api from '@/api'

export default {
  isGroup () {
    const type = this.userType()
    if (type === '1') {
      return true
    } else {
      return false
    }
  },
  getAppCode () {
    const type = this.userType()
    let str = ''
    if (type === '1') {
      str = 'tyrtfgd5'
    } else {
      str = 'pdc7vkn6'
    }
    return str
  },
  userTypeStr () {
    const type = this.userType()
    let str = ''
    if (type === '1') {
      str = 'GROUP'
    } else {
      str = 'INDI'
    }
    return str
  },
  userType () {
    const type = Vue.ls.get('type')
    return type
  },
  getRefundUrl () {
    if (this.isGroup()) {
      return api.groupRefund
    } else {
      return api.individualRefund
    }
  },
  getOrderDetailUrl () {
    if (this.isGroup()) {
      return api.groupOrderDetail
    } else {
      return api.indiOrderDetail
    }
  },
  getOrderRefundDetailUrl() {
    if (this.isGroup()) {
      return api.groupOrderRefundDetail
    } else {
      return api.indiOrderRefundDetail
    }
  },
  getUnifiedUrl () {
    if (this.isGroup()) {
      return api.groupUnifiedOrder
    } else {
      return api.indiUnifiedOrder
    }
  },
  isLogin () {
    const token = Vue.ls.get('token')
    const type = Vue.ls.get('type')
    if (token && type !== null) {
      return true
    } else {
      return false
    }
  },
  //Add by LiuHui at 20201118 for 聚合支付 begin
  orderSource () {
    return "PC"
  },
  isWechatPay (payType) {//是否微信支付
    if (payType === 'WEIXIN') {
      return true
    }
    return false
  },
  //Add by LiuHui at 20201118 for 聚合支付 end
  // excelUrl: 'http://pkg.test.sjtickettech.com/guide_template.xlsx'
  // excelUrl: 'https://static.yhypark.sjtickettech.com/pc/guide_template.xlsx'
  excelUrl: 'http://web.wx.sjtickettech.com/yhy/data/guide_template.xlsx'
}
